<template>
  <div>
    <div class="tw-my-4"><back-nav to="SelectOption" /></div>
    <v-card class="tw-pb-12 tw-px-4">
      <card-title icon="mdi-autorenew">Review Personal Details</card-title>
      <div class="tw-px-0 md:tw-px-10 xl:tw-px-16 tw-mt-4 md:tw-mt-10">
        <v-form v-model="isValid">
          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
            <v-text-field
                v-model="form.fullName"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Full Name"
                type="text"
                :rules="[required('Full Name')]"
                :disabled="!!form.fullName"
            ></v-text-field>
            <v-text-field
                v-model="form.mobileNumber"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Mobile No."
                type="text"
                :rules="[required('Mobile No.'), mobileFormat()]"
                :disabled="!!form.mobileNumber"
            ></v-text-field>
            <v-text-field
                v-model="form.email"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Email"
                type="text"
                :rules="[required('Email'), emailFormat()]"
                :disabled="!!form.email"
            ></v-text-field>
            <v-text-field
                v-model="form.idNumber"
                class="my-2 tw-px-0 md:tw-px-6"
                label="ID No."
                type="number"
                :rules="[required('ID No.'), nationalIdFormat()]"
                :disabled="!!renewalClient.id"
            ></v-text-field>
            <v-text-field
                v-model="form.poBoxNo"
                class="my-2 tw-px-0 md:tw-px-6"
                label="PO Box No."
                type="number"
                :rules="[required('PO Box No.')]"
            ></v-text-field>
            <v-autocomplete
                v-model="form.postalCode"
                :loading="postCodeLoading"
                :items="postCodeItems"
                :search-input.sync="postCodeSearch2"
                class="my-2 tw-px-0 md:tw-px-6"
                hide-no-data
                hide-details
                label="Postal Code"
                :rules="[required('Postal Code')]"
            ></v-autocomplete>
            <v-text-field
                v-model="form.kraPinNumber"
                class="my-2 tw-px-0 md:tw-px-6"
                label="KRA PIN"
                type="text"
                :rules="[required('KRA PIN'), kraPinFormat()]"
                :disabled="!!form.kraPinNumber"
            ></v-text-field>
            <v-radio-group
                v-model="form.gender"
                class="my-2 tw-px-0 md:tw-px-6"
                :rules="[required('Gender')]"
                row>
              <v-radio label="Male" value="MALE" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
              <v-radio label="Female" value="FEMALE" class="tw-mt-0 md:tw-mt-5"></v-radio>
            </v-radio-group>
          </div>

          <div class="tw-w-full">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Renewal start date.</h3>
            <hr class="tw-mt-3 tw-mb-5">
          </div>

          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mt-4 md:tw-mt-10 tw-px-2 md:tw-px-8">
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="computedDateFormatted"
                    label="Start Date"
                    persistent-hint
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[required('Start Date')]"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" :min="new Date().toISOString().substr(0, 10)" no-title @input="menu = false" color="primary"></v-date-picker>
            </v-menu>
          </div>

          <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
            <v-btn block large
                   color="secondary"
                   class="my-3 "
                   :loading="loading"
                   :disabled="!isValid"
                   @click="continueRenew"
            >
              {{ isValid ? 'Continue' : 'Check if all fields are filled' }}
            </v-btn>
          </v-card-actions>

        </v-form>
      </div>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions,no-unused-vars,no-return-assign,no-param-reassign */

import CardTitle from '@/components/shared/CardTitle';
import validations from '@/utils/validations';
import {
  changeFormat, diffDate, formatDate, formatDate2,
} from '@/utils/time';
import axios from 'axios';
import postalCodes from '@/utils/postalCodes.json';
import { mapGetters } from 'vuex';
import BackNav from '@/components/buy/BackNav';
import { FB_RENEW_REVIEW_PERSONAL_DETAILS } from '@/utils/const';
import moment from 'moment';

export default {
  name: 'PersonalDetailsReview',
  components: { BackNav, CardTitle },
  props: {
    changeCover: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    date: '',
    menu: false,
    loading: false,
    isValid: false,
    form: {},
    pageLoading: true,
    ...validations,
    postCodeLoading: false,
    postCodeItems: [],
    postCodeSearch2: null,
  }),
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
    computedDateFormatted() {
      return this.form.coverFrom || this.formatDate(this.date);
    },
    policy() {
      return this.$store.state.policy;
    },
    renewalClient() {
      return this.$store.getters['renewal/renewalClient'];
    },
  },
  watch: {
    postCodeSearch2(val) {
      val && val !== this.form.postalCode && this.postCodeFilter2(val);
    },
    date(val) {
      this.form.coverFrom = this.formatDate(this.date);
    },
  },
  mounted() {
    this.form = {
      fullName: this.policy.clientName || this.authenticatedUser.name,
      mobileNumber: this.renewalClient.mobileNo || this.authenticatedUser.phone_number,
      email: this.renewalClient.email || this.authenticatedUser.email,
      idNumber: this.renewalClient.id,
      poBoxNo: this.renewalClient.postalAddress,
      postalCode: this.renewalClient.postalCode,
      kraPinNumber: this.renewalClient.pinNo || this.authenticatedUser['custom:kra-pin'],
      gender: this.renewalClient.gender,
      coverFrom: !diffDate(this.policy.renewalDate) ? this.formatDate(this.policy.renewalDate) : moment().format('DD/MM/YYYY'),
    };
    this.form.mobileNumber = this.form.mobileNumber.startsWith('07') ? `+254${this.form.mobileNumber.substring(1)}` : this.form.mobileNumber;
    this.postCodeItems = [this.renewalClient.postalCode];
  },
  methods: {
    async continueRenew() {
      this.loading = true;
      const requestData = {
        batchNo: this.$route.params.batchNo,
        coverTypeID: this.policy.coverCode,
        dateFormat: 'dd/MM/yyyy',
        emailId: this.form.email,
        idNumber: this.form.idNumber,
        kraPinNumber: this.form.kraPinNumber,
        mobileNo: this.form.mobileNumber,
        physicalAddress: this.form.postalCode,
        postalAddress: this.form.poBoxNo,
        prodId: this.policy.productCode,
        renewalDate: this.computedDateFormatted,
        fullName: this.form.fullName,
        status: 0,
        timestamp: 0,
        origin: 'P',
      };
      await axios.post('/customer/quotation/renewal/policy', requestData)
        .then((response) => {
          if (response.data.success) {
            this.$toast.success('Personal Details confirmed successfully', 'Personal Details');
            if (this.changeCover) {
              const { batchId } = response.data.data;
              this.$toast.info('Preparing to change cover...', 'Changing cover');
              axios.post('/customer/quotation/renewal/changeplan', { batchId, riskId: 0 })
                .then((resp) => {
                  this.loading = false;
                  if (resp.data.success) {
                    this.$toast.success('Proceed to Chnanging cover', 'Change Cover');
                    this.$emit('to-switch-cover', { quote: resp.data.data, batchId });
                  } else {
                    this.$toast.success('Please try again !', 'Change Cover Error');
                    this.$root.$emit('nav-back-to', { currentTab: 'SelectOption' });
                  }
                  //
                });
            } else {
              this.loading = false;
              this.$analytics.logEvent(FB_RENEW_REVIEW_PERSONAL_DETAILS, { product: 'Renewal Journey Review Personal Details' });
              this.$emit('to-vehicle-details-review', { data: response.data.data, switchedCover: false });
            }
          } else {
            this.loading = false;
            this.$toast.success(response.data.msg, 'Renewal', { timeout: 15000 });
            this.$router.push({ name: 'MyPolicies' });
          }
        });
    },
    formatDate,
    formatDate2,
    changeFormat,
    postCodeFilter2(v) {
      this.postCodeLoading = true;
      setTimeout(() => {
        this.postCodeItems = postalCodes.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
        this.postCodeLoading = false;
      }, 500);
    },
  },
};
</script>
